import marked from "marked";


export function markdownToHtml(label, params = {}) {
	let myRenderer = new marked.Renderer();
	myRenderer.link = function (href, title, text) {

		if (!params.readOnlyLinks) {
			let external, newWindow, out;
			external = /^((https?|facetime):\/\/|(sms|tel|mailto|skype):).+$/.test(href);
			newWindow = external || title === "newWindow";

			//// console.log(`href: ${href}, title: ${title}, text: ${text}`);

			if (href.toLowerCase().startsWith("goto:") ||
				href.toLowerCase().startsWith("newsessionandgoto:") ||
				href.toLowerCase().startsWith("gotoandreturn:") ||
				href.toLowerCase().startsWith("newsessionandgotoandreturn:") ||
				href.toLowerCase().startsWith("goback") ||
				href.toLowerCase().startsWith("resetcurrentactivity") ||
				href.toLowerCase().startsWith("resetcurrentlist") ||
				href.toLowerCase().startsWith("resetcurrentsection") ||
				href.toLowerCase().startsWith("resetrangeandgoto:") ||
				href.toLowerCase().startsWith("gotoandopenbirdseyeview:") ||
				href.toLowerCase().startsWith("openmodalitem") ||
				href.toLowerCase().startsWith("showmodalitem") ||
				href.toLowerCase().startsWith("opencomments") ||
				href.toLowerCase().startsWith("opennotes") ||
				href.toLowerCase().startsWith("openmedia") ||
				href.toLowerCase().startsWith("opensketchpad")) {
				out = `<a onClick="event.stopPropagation(); playerActionsInlineLinkUrl('${href}',${params.listIndex}, ${params.sectionIndex}, ${params.itemIndex});" href='#' `;
			} else {
				out = "<a href=\"" + href + "\"";
				if (params.stopLinkEventPropagation) {
					out += " onClick=\"event.stopPropagation();\"";
				}
			}

			if (newWindow) {
				out += " target=\"_blank\"";
			}
			if (title && title !== "newWindow") {
				out += " title=\"" + title + "\"";
			}

			return out += ">" + text + "</a>";
		} else {
			let	out = "<a href=\"javascript:void(0)\"";			
			if (title) {
				out += " title=\"" + title + "\"";
			}
			return out += ">" + text + "</a>";
		}
	};

	myRenderer.image = function (href, title, text) {
		return "<img style=\"max-width: 100%\" src=\"" + href + "\" /><br/><div>" + text + "</div>";
	};

	// myRenderer.paragraph = function (text) {
	// 	return text;
	// };

	marked.setOptions({
		renderer: myRenderer,
		gfm: true,
		tables: true,
		breaks: true,
		pedantic: false,
		sanitize: false,
		smartLists: true,
		smartypants: false
	});

	return { __html: marked(label) };
}